export default __webpack_public_path__ + "static/media/32_Bazant_obecny_Mihaly_upr.8b4c5b42.mp3";